import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { auditActionLabel, formatDateTime, hasPermission, staffSections } from '../lib/permissions';
import '../styles/adminResponsive.css';
import '../styles/adminMembers.css';

// Plain-language summary of what the staff role allows; the server enforces the same list.
const DUTIES = [
  ['pool.view', 'Dış mekân ve organizatör kayıtlarını hazırlamak, düzenlemek ve yayınlamak'],
  ['review.dna', 'Yeni profilleri ve önemli profil değişikliklerini incelemek'],
  ['reports.review', 'Şikâyetleri incelemek ve gerektiğinde iletişimi 24 saat veya süresiz askıya almak (süresiz askıyı yalnız ana yönetici kaldırır)'],
  ['events.verify', 'Taraflarca çelişkili bildirilen veya 7 gün içinde ikinci teyidi gelmeyen etkinlikleri gerekçeyle doğrulamak ya da reddetmek'],
];

export default function StaffHome() {
  const { user } = useAuth();
  const sections = staffSections(user);
  const [activity, setActivity] = useState({ items: [], loading: true, error: '' });
  const [openNeeds, setOpenNeeds] = useState(0);
  const canSeeNeeds = hasPermission(user, 'pool.view');
  useEffect(() => {
    let alive = true;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/audit`, { params: { limit: 10 }, timeout: 12000 })
      .then(({ data }) => { if (alive) setActivity({ items: data?.items || [], loading: false, error: '' }); })
      .catch(() => { if (alive) setActivity({ items: [], loading: false, error: 'İşlem geçmişin şu anda yüklenemedi.' }); });
    return () => { alive = false; };
  }, []);
  // A10 son denetim: aramada sonuç çıkmayan açık havuz ihtiyaçları görev listesinde sayı olarak görünür.
  useEffect(() => {
    if (!canSeeNeeds) return undefined;
    let alive = true;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/pool/needs`, { params: { status: 'open' }, timeout: 12000 })
      .then(({ data }) => { if (alive) setOpenNeeds(Number.isInteger(data?.total) ? data.total : 0); })
      .catch(() => { if (alive) setOpenNeeds(0); });
    return () => { alive = false; };
  }, [canSeeNeeds]);
  return <section className="p-8 max-w-5xl mx-auto admin-responsive-page" data-testid="staff-home">
    <div className="mb-6">
      <p className="text-sm font-semibold" style={{ color: 'var(--blue-text)' }}>Havuz Yöneticisi</p>
      <h1 className="text-3xl font-semibold">Merhaba {user?.name}</h1>
      <p className="mt-2">Bu panelde yalnız sana verilen personel işlerini görürsün. Üyelik, ödeme ve sistem ayarları ana yöneticidedir.</p>
    </div>
    <section className="admin-member-card admin-member-panel mb-6" aria-labelledby="staff-duties">
      <h2 id="staff-duties" className="font-semibold mb-3">Görevlerin</h2>
      <ul className="list-disc pl-5 space-y-1">
        {DUTIES.filter(([perm]) => hasPermission(user, perm)).map(([perm, text]) => <li key={perm}>{text}</li>)}
        {canSeeNeeds && openNeeds > 0 && <li data-testid="staff-task-pool-needs">
          {openNeeds} açık havuz ihtiyacı: aramada uygun profil çıkmayan istekler için havuza kayıt eklemeyi değerlendir.{' '}
          <Link to="/admin/pool?panel=needs" className="text-action">Havuz ihtiyaçlarını aç</Link>
        </li>}
      </ul>
      {sections.length ? <div className="admin-member-actions mt-4">
        {sections.map(section => <Link key={section.path} to={section.path} className="action-secondary" data-testid={`staff-section-${section.path.split('/').pop()}`}>{section.label}</Link>)}
      </div> : <p className="mt-4" data-testid="staff-home-pending">Çalışma ekranların hazırlanınca bu sayfada ve menüde görünecek. Şimdilik yapman gereken bir işlem yok.</p>}
    </section>
    <section className="admin-member-card admin-member-panel" aria-labelledby="staff-activity">
      <h2 id="staff-activity" className="font-semibold mb-3">Son işlemlerin</h2>
      {activity.loading ? <p role="status">Yükleniyor…</p>
        : activity.error ? <p role="alert">{activity.error}</p>
          : !activity.items.length ? <p>Henüz kayıtlı bir işlemin yok.</p>
            : <ul className="admin-staff-activity">{activity.items.map(item => <li key={item.id}>
              <strong>{auditActionLabel(item.action)}</strong><span>{formatDateTime(item.at)}</span>
            </li>)}</ul>}
    </section>
  </section>;
}
